// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ADD_CAMERA = 'ADD_CAMERA';
export const IS_ANNOTATION = 'IS_ANNOTATION';
export const CHECK_IMAGE = 'CHECK_IMAGE';
export const CAMERA_DATA = 'CAMERA_DATA';
export const ZONE_DATA = 'ZONE_DATA';
export const SELECTED_CAMERA = 'SELECTED_CAMERA';
export const NEW_ZONES = 'NEW_ZONES';
export const SHOW_ZONE_INPUT = 'SHOW_ZONE_INPUT';
export const POLYGON_DETAILS = 'POLYGON_DETAILS';
export const SAVED_POLYGONS = 'SAVED_POLYGONS';
export const VIDEO_PLAYING = 'VIDEO_PLAYING';
export const POLYGON_TYPE = 'POLYGON_TYPE';
export const POLYGON_COMPLETE = 'POLYGON_COMPLETE';
export const DELETE_POLYGON = 'DELETE_POLYGON';
export const CLEAR_ALL_POLYGONS = 'CLEAR_ALL_POLYGONS';
export const SET_ZONE_NAME = 'SET_ZONE_NAME';
export const SET_BORDER_LINE_NAME = 'SET_BORDER_LINE_NAME';
export const SET_CAMERA_IMAGE = 'SET_CAMERA_IMAGE';
export const CAMERA_ADDED = 'CAMERA_ADDED';
export const RESET_CAMERA_ADDED = 'RESET_CAMERA_ADDED';
export const SET_CAMERA_SOURCE = 'SET_CAMERA_SOURCE';
export const SET_DEPARTMENTS = 'SET_DEPARTMENTS';

// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const MENU_TYPE = '@customization/MENU_TYPE';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
export const CURRENT_DATE = '@customization/CURRENT_DATE';
export const SELECTED_TIME = '@customization/SELECTED_TIME';
export const SET_SELECTED_ZONES = '@customization/SET_SELECTED_ZONES';
export const SIDEBAR_STATE = '@customization/SIDEBAR_STATE';
